class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      const cartDrawerItems = this.querySelector("cart-drawer-items");
      if (cartDrawerItems) {
        cartDrawerItems.updateCartUpsellToggleState();
        cartDrawerItems.updateCartUpsellVisibility();
      }
      // Dispatch cart:open event
      document.dispatchEvent(new CustomEvent('cart:open'));
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      if(document.querySelector('#ProductInfo-product-bundle')) {
        window.location.href = "/cart";
      } else {
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);


function waitForCondition(fn, interval = 100, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const timer = setInterval(() => {
      try {
        if (fn()) {
          clearInterval(timer);
          resolve(true);
        } else if (Date.now() - start > timeout) {
          clearInterval(timer);
          reject("Timeout waiting for condition");
        }
      } catch (e) {}
    }, interval);
  });
}
// Utility: Wait until an element exists (supports shadow DOM)
function waitForElement(selector, root = document, interval = 100, timeout = 8000) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const timer = setInterval(() => {
      const el = root.querySelector(selector);
      if (el) {
        clearInterval(timer);
        resolve(el);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(timer);
        reject(`Timeout waiting for selector: ${selector}`);
      }
    }, interval);
  });
}

function isSendButtonEnabled(button) {
  if (!button) return false;
  // Common patterns: disabled attribute, aria-disabled, or disabled class
  if (button.disabled) return false;
  const aria = button.getAttribute && button.getAttribute('aria-disabled');
  if (aria && aria !== 'false') return false;
  const cls = button.className || '';
  if (/\b(disabled|is-disabled|btn--disabled)\b/.test(cls)) return false;
  // If the button is visible and not disabled, treat it as enabled
  return true;
}

// Main function to send the message to Shopify Inbox
async function sendCartToShopifyInbox(message) {
  // const inbox = document.querySelector("inbox-online-store-chat");

  // if (!inbox) {
  //   console.warn("⚠️ Shopify Inbox not found on this page.");
  //   return;
  // }

  // const shadow = inbox.shadowRoot;

  // const chatIsOpen = shadow.querySelector(".chat-app--is-open");

  // if (!chatIsOpen) {
  //   console.log("💬 Chat is closed — opening it...");
  //   const toggleBtn = shadow.querySelector(".chat-toggle");
  //   if (!toggleBtn) {
  //     console.warn("⚠️ Chat toggle button not found.");
  //     return;
  //   }
  //   toggleBtn.click();

  //   await waitForElement(".chat-app--is-open", shadow);
  // } else {
  //   console.log("💬 Chat is already open.");
  // }

  // if(shadow.querySelector(".hover-effect-button")) {
  //   shadow.querySelector(".hover-effect-button").click();
  // }

  // const textBox = await waitForElement(".composer-bar__message-text", shadow);
  // const sendButton = await waitForElement(".composer-bar__footer-button", shadow);

  // textBox.value = message;
  // textBox.dispatchEvent(new Event("input", { bubbles: true }));
  // textBox.dispatchEvent(new Event("change", { bubbles: true }));

  // try {
  //   await waitForCondition(() => isSendButtonEnabled(sendButton), 50, 5000);
  // } catch (err) {
  //   console.warn("Send button didn't enable in time — will still try fallback sending.");
  // }

  // try {
  //   sendButton.click();
  // } catch (err) {
  //   console.warn("Send button click threw error:", err);
  // }

  sendCartToShopifyInbox(message);
}

function sendCartToShopifyInbox(message) {
  const phone = "33763872318";
  const encodedMessage = encodeURIComponent(message);

  const url = `https://wa.me/${phone}?text=${encodedMessage}`;
  
   window.location.href = url;
}

document.addEventListener("click", async function (e) {
  if (e.target.closest(".cart-share")) {
    try {
      const asdsd = `Merci ma beauté${"\n"}${"\n"}Nous venons de recevoir le détail de ta jolie box !${"\n"}Nous avons actuellement une très forte demande. Chaque création étant réalisée en quantité limitée, et fait main, nous vérifions les disponibilités et te ferons un retour sous 24h pour te confirmer la prochaine date de confection princesse ${"\n"}En te souhaitant de beaux préparatifs !${"\n"}${"\n"}Sarah & Sophia${"\n"}${"\n"}
       ${"\n"}`;
      const response = await fetch("/cart.js");
      const cart = await response.json();

      // Handle discount code display
      let discountText = "";
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        discountText = cart.cart_level_discount_applications.map((discount) => {
          let savedAmount = "";
          if (discount.value_type === "percentage") {
            savedAmount = `Remise: -${discount.value}%`;
          } else if (discount.value_type === "fixed_amount") {
            savedAmount = `Remise: -${window.Shopify.formatMoney(discount.value)}`;
          }
          // Show total saved in money if available
          let totalSaved = "";
          if (discount.total_allocated_amount) {
            totalSaved = `Économisé: ${window.Shopify.formatMoney(discount.total_allocated_amount)}`;
          }
          return `\nCode promo appliqué: ${discount.title}\n${savedAmount}${totalSaved ? "\n" + totalSaved : ""}\n------------------------------`;
        }).join("\n");
      }

      console.log(discountText);
      

      const cartItemsInfo = cart.items.map((item) => {
        let propertiesText = "";
        const properties = Object.entries(item.properties).filter(([key]) => !key.startsWith("_"));
        if (properties && properties.length > 0) {
          propertiesText = properties
            .filter(([key]) => key !== "_oz-key") 
            .map(([key, value]) => `${key}: ${value}`)
            .join("\n");
        } 
        return ` ${item.product_title}
        ${window.Shopify.formatMoney(item.price * item.quantity)}
        ${item.variant_title ? "Variant: " + item.variant_title + "\n" : ""}
        ${propertiesText ? propertiesText + "\n" + "\n" : ""}------------------------------`.replace(/^[ \t]+/gm, "").trim();
      });
      const formattedCartText =
        asdsd +
        cartItemsInfo.join("\n\n") +
        (discountText ? discountText + "\n" : "") +
        `${"\n"}Total estimé: ${window.Shopify.formatMoney(cart.total_price)}${"\n"}------------------------------`;
      await sendCartToShopifyInbox(formattedCartText);
    } catch (err) {
      console.error("❌ Error:", err);
    }
  }
});